module.exports = __webpack_public_path__ + "static/EM1-0d17790918551ffcc2775b8dd4c0b4ef.png";